module.exports = __webpack_public_path__ + "img/shate.9a758be0.png";